// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables CSS */
:root {
  --bg-light: #efefef;
  --bg-dark: #707070;
  --clr: #6A9E2C;
  --clr-hover: #8CC63E;
  --clr-alpha: #9c9c9c60;
  --card-bg: rgba(255, 255, 255, 0.85);
  --card-border: rgba(255, 255, 255, 0.6);
  --input-bg: rgba(255, 255, 255, 0.7);
  --input-border: rgba(0, 0, 0, 0.08);
  --shadow-card: 0 20px 60px rgba(0, 0, 0, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Contenedor principal con overlay sobre la imagen */
.login-container {
  position: relative;
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.login-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(106, 158, 44, 0.15) 0%,
    rgba(0, 0, 0, 0.25) 60%,
    rgba(0, 0, 0, 0.35) 100%
  );
  pointer-events: none;
  z-index: 0;
}

.login-content {
  flex: 1 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 24px;
}

/* Tarjeta con glass-morphism */
.login-card {
  width: 100%;
  max-width: 420px;
  background: var(--card-bg);
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
  border-radius: 24px;
  border: 1px solid var(--card-border);
  box-shadow: var(--shadow-card);
  padding: 44px 40px 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  animation: cardFadeIn 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.logo-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
}

.logo-wrapper img {
  max-width: 200px;
  height: auto;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.08));
}

.welcome-text {
  text-align: center;
  margin: 4px 0 12px;
}

.welcome-text h1 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #2c2c2c;
  letter-spacing: -0.01em;
}

.welcome-text p {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #6b6b6b;
}

/* Formulario */
.form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1rem;
  width: 100%;
  max-width: 100%;
}

.input-span {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.label {
  align-self: flex-start;
  color: var(--clr);
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.02em;
}

/* Botón principal con gradiente */
.btn-login {
  position: relative;
  padding: 0.85rem 1rem;
  width: 100%;
  border-radius: 14px;
  background: linear-gradient(135deg, var(--clr) 0%, var(--clr-hover) 100%);
  color: #ffffff;
  border: none;
  cursor: pointer;
  transition: transform 200ms ease, box-shadow 200ms ease, filter 200ms ease;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 8px 20px rgba(106, 158, 44, 0.35);
}

.btn-login:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(106, 158, 44, 0.45);
  filter: brightness(1.05);
}

.btn-login:active:not(:disabled) {
  transform: translateY(0);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Footer */
.login-footer {
  width: 100%;
  text-align: center;
  padding: 14px 16px;
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.login-footer span {
  color: #ffffff;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  opacity: 0.9;
}

/* Responsive */
@media (max-width: 480px) {
  .login-card {
    padding: 32px 24px 28px;
    border-radius: 20px;
  }
  .welcome-text h1 {
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/LoginPageStyles.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,oCAAoC;EACpC,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,6EAA6E;AAC/E;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,yEAAyE;EACzE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,0EAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Variables CSS */\n:root {\n  --bg-light: #efefef;\n  --bg-dark: #707070;\n  --clr: #6A9E2C;\n  --clr-hover: #8CC63E;\n  --clr-alpha: #9c9c9c60;\n  --card-bg: rgba(255, 255, 255, 0.85);\n  --card-border: rgba(255, 255, 255, 0.6);\n  --input-bg: rgba(255, 255, 255, 0.7);\n  --input-border: rgba(0, 0, 0, 0.08);\n  --shadow-card: 0 20px 60px rgba(0, 0, 0, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Contenedor principal con overlay sobre la imagen */\n.login-container {\n  position: relative;\n  height: 100vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n}\n\n.login-container::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(106, 158, 44, 0.15) 0%,\n    rgba(0, 0, 0, 0.25) 60%,\n    rgba(0, 0, 0, 0.35) 100%\n  );\n  pointer-events: none;\n  z-index: 0;\n}\n\n.login-content {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n  padding: 24px;\n}\n\n/* Tarjeta con glass-morphism */\n.login-card {\n  width: 100%;\n  max-width: 420px;\n  background: var(--card-bg);\n  backdrop-filter: blur(18px) saturate(160%);\n  -webkit-backdrop-filter: blur(18px) saturate(160%);\n  border-radius: 24px;\n  border: 1px solid var(--card-border);\n  box-shadow: var(--shadow-card);\n  padding: 44px 40px 36px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  animation: cardFadeIn 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes cardFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(24px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.logo-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.logo-wrapper img {\n  max-width: 200px;\n  height: auto;\n  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.08));\n}\n\n.welcome-text {\n  text-align: center;\n  margin: 4px 0 12px;\n}\n\n.welcome-text h1 {\n  margin: 0;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #2c2c2c;\n  letter-spacing: -0.01em;\n}\n\n.welcome-text p {\n  margin: 4px 0 0;\n  font-size: 0.85rem;\n  color: #6b6b6b;\n}\n\n/* Formulario */\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 1rem;\n  width: 100%;\n  max-width: 100%;\n}\n\n.input-span {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.label {\n  align-self: flex-start;\n  color: var(--clr);\n  font-weight: 600;\n  font-size: 0.85rem;\n  letter-spacing: 0.02em;\n}\n\n/* Botón principal con gradiente */\n.btn-login {\n  position: relative;\n  padding: 0.85rem 1rem;\n  width: 100%;\n  border-radius: 14px;\n  background: linear-gradient(135deg, var(--clr) 0%, var(--clr-hover) 100%);\n  color: #ffffff;\n  border: none;\n  cursor: pointer;\n  transition: transform 200ms ease, box-shadow 200ms ease, filter 200ms ease;\n  font-weight: 700;\n  font-size: 0.95rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  box-shadow: 0 8px 20px rgba(106, 158, 44, 0.35);\n}\n\n.btn-login:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(106, 158, 44, 0.45);\n  filter: brightness(1.05);\n}\n\n.btn-login:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-login:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Footer */\n.login-footer {\n  width: 100%;\n  text-align: center;\n  padding: 14px 16px;\n  position: relative;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.login-footer span {\n  color: #ffffff;\n  font-size: 0.8rem;\n  letter-spacing: 0.02em;\n  opacity: 0.9;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .login-card {\n    padding: 32px 24px 28px;\n    border-radius: 20px;\n  }\n  .welcome-text h1 {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
